import { ONE_SECOND } from 'Lib/constants/time';

export const SLIDE_TRANSITION_INTERVAL_MS = 5 * ONE_SECOND;
